<template>
  <div class="file-handler col-12">
    <!-- Box of uploaded file -->
    <UploadedFile
      v-if="isSubmitted[number]"
      :text="`${$t('Uploaded image')} ${number}`"
      @edited-file="editFile()"
      @deleted-file="deleteFile()"
    />
    <!-- File uploader button -->
    <FileUploader
      v-show="empty(file)"
      classes="form-group"
      :number="number"
      :name="inputName"
    />
    <!-- Cropper -->
    <Cropper
      v-if="!empty(file) && !isSubmitted[number]"
      :number="number"
      :image-url="file"
      @save-modified="saveModified"
    />
    <!-- Field for invoking errors -->
    <div class="form-group" v-if="!isSubmitted[number]">
      <Field
        v-if="!empty(file)"
        name="unsaved_file"
        type="hidden"
        rules="required"
      />
      <Field v-else name="original_file" type="hidden" rules="required" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { empty } from "../../../../../helpers";
import { Field } from "vee-validate";
import Cropper from "./Cropper";
import FileUploader from "./Button";
import store from "../../../../store";
import useModal from "../../../../useModal";
import usePhoto from "./../../usePhoto";
import UploadedFile from "./../../../partials/image-handler/UploadedFile";

export default {
  components: {
    Cropper,
    FileUploader,
    Field,
    UploadedFile,
  },
  props: {
    number: {
      type: Number,
      default: () => 1,
    },
  },
  computed: {
    ...mapGetters({
      product: "product/getProduct",
      files: "photoUploader/getFiles",
      isSubmitted: "photoUploader/getIsSubmitted",
      cropper: "photoCropper/getFiles",
    }),
    file() {
      return this.files[this.number];
    },
    inputName() {
      return `originalCollage${this.number}`;
    },
  },
  methods: {
    saveModified() {
      this.setIsSubmitted(this.number, true);
    },
    editFile() {
      this.setIsSubmitted(this.number, false);
    },
    deleteFile() {
      this.deleteFileModal(() => {
        store.commit(`${this.uploaderNamespace}SET_FILE`, {
          index: this.number,
          value: null,
        });
        store.commit(`${this.cropperNamespace}SET_FILE`, {
          index: this.number,
          value: null,
        });
        this.setIsSubmitted(this.number, false);
        // clear input data
        document.querySelector(`#${this.inputName}`).value = "";
      });
    },
  },
  setup(props) {
    const { deleteFileModal } = useModal();
    const { uploaderNamespace, cropperNamespace, setIsSubmitted } = usePhoto();
    const isSubmittedFile =
      store.getters[`${uploaderNamespace}getIsSubmitted`][props.number];
    // if not set submitted, then set false
    if (!isSubmittedFile) {
      setIsSubmitted(props.number, false);
    }

    return {
      cropperNamespace,
      uploaderNamespace,
      setIsSubmitted,
      empty,
      deleteFileModal,
    };
  },
};
</script>
